import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
export const exportToExcel = (headerDataSet,dataset, fileName) => {
//For scorecard email export functionality as per requirement, the below code is customized. 
//For generic export of single dataset one could pass empty headerDataSet and actual data to dataset which will work expected.
    // Step 1: Convert headerDataSet to an array of arrays (needed for xlsx)
  const headerData = XLSX.utils.json_to_sheet(headerDataSet);
  const headerDataArray = XLSX.utils.sheet_to_json(headerData, { header: 1 });

  // Step 2: Convert dataset to an array of arrays
  const data = XLSX.utils.json_to_sheet(dataset);
  const dataArray = XLSX.utils.sheet_to_json(data, { header: 1 });

  // Step 3: Add an empty row between datasets to separate them visually
  const separator = new Array(headerDataArray[0].length).fill(''); // Empty row of same length
  const mergedData = [...headerDataArray.slice(1), separator, ...dataArray]; // Merge both datasets with separator

 //const worksheet = XLSX.utils.json_to_sheet(data); // convert JSON to a worksheet
 const worksheet = XLSX.utils.aoa_to_sheet(mergedData);
 const workbook = XLSX.utils.book_new(); // create a new workbook
 XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1"); // add the worksheet to the workbook
//  const excelBuffer = XLSX.writeFile(workbook, { bookType: "xlsx", type: "array" });
//  const file = new Blob([excelBuffer], { type: "application/octet-stream" });
 XLSX.writeFile(workbook, `${fileName}.xlsx`);
};